import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService, LangCode } from '../../core/services/language.service';

@Component({
  selector: 'app-floating-chat',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floating-chat.component.html',
  styleUrl: './floating-chat.component.scss'
})
export class FloatingChatComponent {
  // ===== Props configurables =====
  @Input() phone = '51999999999';
  @Input() advisorName = 'Malena Flores';
  @Input() advisorRole = 'Asesora Comercial';
  @Input() presetMessage?: string;   // si no llega, usamos el del diccionario
  @Input() avatarUrl?: string;
  @Input() online = true;

  open = false;

  // ===== i18n =====
  private lang = inject(LanguageService);

  private dict: Record<LangCode, any> = {
    es: {
      chat: {
        button: '¡Hola, escríbenos!',
        header: 'Estamos en línea para darte la mejor atención',
        whatsapp: 'Chatear por WhatsApp',
        dialogAria: 'Chat con asesor',
        onlineLabel: 'Asesor en línea',
        busyLabel: 'Asesor ocupado',
        online: 'En línea',
        busy: 'Ocupado',
        close: 'Cerrar',
        defaultMessage: 'Hola, me gustaría recibir información sobre sus equipos.'
      }
    },
    en: {
      chat: {
        button: 'Hi! Chat with us',
        header: 'We’re online to help you',
        whatsapp: 'Chat on WhatsApp',
        dialogAria: 'Chat with advisor',
        onlineLabel: 'Advisor online',
        busyLabel: 'Advisor busy',
        online: 'Online',
        busy: 'Busy',
        close: 'Close',
        defaultMessage: 'Hi, I’d like to get information about your equipment.'
      }
    },
    pt: {
      chat: {
        button: 'Olá, fale conosco!',
        header: 'Estamos on-line para atendê-lo',
        whatsapp: 'Conversar no WhatsApp',
        dialogAria: 'Chat com consultor',
        onlineLabel: 'Consultor on-line',
        busyLabel: 'Consultor ocupado',
        online: 'On-line',
        busy: 'Ocupado',
        close: 'Fechar',
        defaultMessage: 'Olá, gostaria de receber informações sobre os equipamentos.'
      }
    },
    ko: {
      chat: {
        button: '안녕하세요, 문의주세요!',
        header: '최상의 상담을 위해 온라인 상태입니다',
        whatsapp: 'WhatsApp으로 채팅',
        dialogAria: '상담원과 채팅',
        onlineLabel: '상담원 온라인',
        busyLabel: '상담원 통화중',
        online: '온라인',
        busy: '바쁨',
        close: '닫기',
        defaultMessage: '안녕하세요, 장비에 대한 정보를 받고 싶습니다.'
      }
    }
  };

  t(path: string): string {
    const obj = this.dict[this.lang.lang];
    return path.split('.').reduce<any>((acc, k) => acc?.[k], obj) ?? path;
  }

  // ===== UI actions =====
  toggle(){ this.open = !this.open; }
  close(){ this.open = false; }

  openWhatsApp(){
    const msg = encodeURIComponent(this.presetMessage ?? this.t('chat.defaultMessage'));
    window.open(`https://wa.me/${this.phone}?text=${msg}`, '_blank');
  }
}
